import React from 'react';
import { EMPTY_GUID } from './Constants';

const defaultGlobalData: GlobalData = {
    tenant: { name: '', logoPath: '', contactSummary: '' },
    communityKey: EMPTY_GUID,
    micrositeKey: EMPTY_GUID,
    canUserEditPage: false,
    isUserAuthenticated: false,
    isUserSuperAdmin: false,
    isUserSiteAdmin: false,
    isUserCommunityAdmin: false,
    isUserCommunityModerator: false,
    currentUserContactKey: EMPTY_GUID,
    isTopicCommunity: false,
    isSelfModerationCommunity: false,
    useCommunityWebApi: false,
    colorPickerDefaults: {
        primaryColor: null,
        textOnPrimary: null,
        secondaryColor: null,
        textOnSecondary: null,
        linkColor: null,
        linkHoverColor: null,
        footerBackgroundColor: null,
        footerTextColor: null
    },
    loginUrl: ''
};

const GlobalDataContext = React.createContext<GlobalData>(defaultGlobalData);
GlobalDataContext.displayName = 'GlobalDataContext';
export { GlobalDataContext };
